<template>
    <div class="view-container">
        <div class="header">
            <div class="login-box">
                <div class="title">{{evaluationName}}</div>
                <div class="user-info">
                    <div class="user-avatar">
                        <img :src="userAvatar ? userAvatar : require('../../assets/images/user_img.png')" alt="">
                    </div>
                    <div class="user-name">{{userName}}</div>
                    <i @click="logoutBtn" class="iconfont logout-btn">&#xe60c;</i>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="menu-box" v-if="showMenu">
                <template v-if="evaluationMenu.length > 0">
                    <el-scrollbar class="levelOne-box">
                        <router-link :to="levelOne.path" class="levelOne"
                                     :class="{current: levelOne.name === $route.name || $route.meta.parentName && $route.meta.parentName.includes(levelOne.name)}"
                                     v-for="levelOne in evaluationMenu" :key="levelOne.name"
                                     v-show="!levelOne.meta.hidden">
                            <i class="iconfont" v-html="levelOne.meta.icon"></i>
                            <span class="icon"></span>
                            <span class="one-text">{{levelOne.meta.title}}</span>
                        </router-link>
                    </el-scrollbar>
                </template>
            </div>
            <div class="main-container">
                <div class="levelTwo-wrapper" v-if="levelTwoMenu.length > 0 && showTab">
                    <router-link :to="levelTwo.path" class="levelTwo"
                                 :class="{current: levelTwo.name === $route.name || $route.meta.parentName.includes(levelTwo.name), single:levelTwoMenu.length === 1, 'wider': ['examPaperManage'].some(item => $route.meta.parentName == item)}"
                                 v-for="levelTwo in levelTwoMenu" :key="levelTwo.name">
                        <span class="two-text">{{levelTwo.meta.title}}</span>
                    </router-link>
                </div>
                <div class="content">
                    <router-view/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {checkCenterLoginOut} from '@/utils/apis'
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                activeIndex: '/examCenter',
                userName: '',
                check_center_name: '',
                userAvatar: '',
                role: '',
                levelTwoMenu: [],
                showTab: true,
                showMenu: true,
                evaluationName:''
            }
        },
        computed: mapState({
            evaluationMenu: state => state.evaluationMenu[0].children,
        }),
        watch: {
            $route(route) {
                this.getLevelTwoMenu(route)
            }
        },
        mounted() {
            this.role = localStorage.getItem('role');
            this.evaluationName = localStorage.getItem('check_center_name');
            // if (this.role === '6') {
            //     this.userName = localStorage.getItem('evaluationName');
            //     this.userAvatar = localStorage.getItem('evaluationAvatar');
            // }
            this.userName = localStorage.getItem('evaluationName');
            this.userAvatar = localStorage.getItem('evaluationAvatar');

            let active = localStorage.getItem('evaluationActive');
            let routeName = this.$route.name;
            if (routeName !== 'evaluationIndex' && active !== undefined && active !== null) {
                this.activeIndex = active
            }
            this.getLevelTwoMenu(this.$route)
        },
        methods: {
            handleSelect(key, keyPath) {
                this.activeIndex = key
                localStorage.setItem('evaluationActive', key)
            },
            // 获取二级菜单
            getLevelTwoMenu(route) {
                if (route.meta.level && route.meta.level === 2) {
                    this.showTab = false
                } else {
                    this.showTab = true
                }
                this.showMenu = route.meta.hiddenMenu ? false : true
                const twoArr = this.evaluationMenu.find(item => {
                    if (route.meta.parentName) {
                        return route.meta.parentName[0] === item.name
                    } else {
                        return item.name === route.name
                    }
                })
                if (twoArr.children) {
                    this.levelTwoMenu = twoArr.children.filter(item => !item.meta.hidden)
                } else {
                    this.levelTwoMenu = []
                }
            },
            // 退出
            logoutBtn() {
                checkCenterLoginOut().then((res) => {
                    localStorage.clear();
                    this.$message({
                        type: "success",
                        message: res.msg,
                        duration: 1000,
                        onClose: () => {
                            this.$router.push('/');
                        }
                    });
                }).catch((err) => {
                    console.log('err',err);
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .view-container {
        width: 100vw;
        height: 100vh;
        min-width: 1200px;
        background: #F7F8FC;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .header {
            width: 100%;
            height: 60px;
            background: #fff;
            box-shadow: 0 2px 5px 0 rgba(15, 26, 54, 0.05);
            display: flex;
            z-index: 9;

            .login-box {
                width: 100%;
                font-size: 16px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;

                .title {
                    font-size: 18px;
                    font-weight: 400;
                    color: #333;
                }

                .user-info {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    .user-avatar {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 40px;
                        height: 40px;
                        margin-right: 10px;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                            border-radius: 50%;
                        }
                    }

                    .user-name {
                        width: 100px;
                        max-height: 50px;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        color: #333;
                    }

                    .logout-btn {
                        cursor: pointer;
                        margin-left: 20px;
                        color: #2DC079;
                    }
                }
            }
        }

        .main {
            width: 100%;
            height: 1%;
            flex: 1;
            display: flex;

            .menu-box {
                width: 210px;
                height: 100%;
                background-color: #fff;
            }

            .levelOne-box {
                position: relative;
                width: 100%;
                height: 100%;
                padding-top: 20px;
                display: flex;
                flex-direction: column;

                ::v-deep .el-scrollbar__wrap {
                    overflow-x: hidden;
                }

                .levelOne {
                    height: 60px;
                    padding: 0 10px 0 30px;
                    display: flex;
                    align-items: center;
                    color: #666;
                    line-height: 1;
                    transition: all .3s;

                    .iconfont {
                        font-size: 16px;
                    }

                    .one-text {
                        font-size: 16px;
                        font-weight: 500;
                        margin-left: 10px;
                    }

                    .icon {
                        display: inline-block;
                        width: 5px;
                        height: 60px;
                        background: transparent;
                        position: relative;
                        z-index: 999;
                        left: -46px;
                    }

                    &:hover {
                        color: #1AB163;
                    }

                    &.current {
                        color: #1AB163;
                        background: #E7F6EF;

                        .icon {
                            background: #1AB163;
                        }
                    }
                }
            }

            .main-container {
                display: flex;
                flex: 1;
                flex-direction: column;
                width: 1%;
                background: #fff;
                margin: 20px;
                overflow: hidden;

                .levelTwo-wrapper {
                    height: 46px;
                    border-bottom: 2px solid #F1F5FF;
                    margin: 20px 20px 0 20px;

                    .levelTwo {
                        display: inline-block;
                        width: 106px;
                        height: 100%;
                        line-height: 46px;
                        border-radius: 4px 4px 0 0;
                        text-align: center;
                        color: #333333;
                        font-size: 16px;

                        &:hover {
                            color: #1AB163;
                        }

                        &.current {
                            color: #1AB163;
                            background: #E7F6EF;
                        }

                        &.single {
                            background: unset;
                            color: #333333;
                            text-align: left;
                        }
                    }
                }
                .wider {
                    width: 123px !important;
                }
                .content {
                    flex: 1;
                    height: 1%;
                    padding-top: 20px;
                }
            }
        }
    }
</style>